export const DEMO_BUSINESS = {
  id: 1,
  name: 'Glow Beauty Salon',
  industry: 'Salon',
  email: 'hello@glowsalon.com',
  phone: '+1 555 234 5678',
  googleBusinessLink: 'https://g.page/glowbeautysalon',
  googleReviewLink: 'https://g.page/glowbeautysalon/review',
  bookingUrl: 'https://calendly.com/glowbeautysalon',
  mailThemeColor: '#6C5CE7',
};

export const DEMO_CUSTOMERS = [
  { id: 1, name: 'Sarah Johnson', email: 'sarah.j@example.com', phone: '+15551234567', lastVisitDate: '2026-04-28T00:00:00Z', createdAt: '2026-04-28T10:00:00Z' },
  { id: 2, name: 'Michael Chen', email: 'michael.c@example.com', phone: '+15559876543', lastVisitDate: '2026-04-25T00:00:00Z', createdAt: '2026-04-25T14:30:00Z' },
  { id: 3, name: 'Emily Rodriguez', email: 'emily.r@example.com', phone: '+15554567890', lastVisitDate: '2026-04-20T00:00:00Z', createdAt: '2026-04-20T09:15:00Z' },
  { id: 4, name: 'David Kim', email: 'david.k@example.com', phone: null, lastVisitDate: '2026-04-30T00:00:00Z', createdAt: '2026-04-30T16:00:00Z' },
  { id: 5, name: 'Lisa Thompson', email: 'lisa.t@example.com', phone: '+15553456789', lastVisitDate: '2026-04-22T00:00:00Z', createdAt: '2026-04-22T11:45:00Z' },
  { id: 6, name: 'James Wilson', email: 'james.w@example.com', phone: '+15556789012', lastVisitDate: '2026-04-18T00:00:00Z', createdAt: '2026-04-18T13:20:00Z' },
  { id: 7, name: 'Amanda Garcia', email: 'amanda.g@example.com', phone: null, lastVisitDate: '2026-04-29T00:00:00Z', createdAt: '2026-04-29T08:00:00Z' },
  { id: 8, name: 'Robert Taylor', email: 'robert.t@example.com', phone: '+15552345678', lastVisitDate: '2026-04-15T00:00:00Z', createdAt: '2026-04-15T17:30:00Z' },
];

export const DEMO_DASHBOARD = {
  totalCustomers: 8,
  maxCustomers: 500,
  emailsSent: 24,
  smsSent: 9,
  whatsappSent: 6,
  scheduledReminders: 12,
  channels: {
    email: { sent: 24, clicked: 9 },
    sms: { sent: 9, clicked: 5 },
    whatsapp: { sent: 6, clicked: 4 },
  },
  recentActivity: [
    { id: 1, type: 'email', category: 'review_request', status: 'sent', deliveryStatus: 'clicked', sentAt: '2026-05-05T14:30:00Z', customer: { name: 'Sarah Johnson', email: 'sarah.j@example.com' } },
    { id: 2, type: 'whatsapp', category: 'reminder', status: 'sent', sentAt: '2026-05-05T13:00:00Z', customer: { name: 'Michael Chen', phone: '+15559876543' } },
    { id: 3, type: 'sms', category: 'reminder', status: 'sent', sentAt: '2026-05-05T12:00:00Z', customer: { name: 'Emily Rodriguez', phone: '+15554567890' } },
    { id: 4, type: 'email', category: 'reminder', status: 'sent', deliveryStatus: 'delivered', sentAt: '2026-05-05T12:00:00Z', customer: { name: 'Emily Rodriguez', email: 'emily.r@example.com' } },
    { id: 5, type: 'email', category: 'review_request', status: 'sent', deliveryStatus: 'clicked', sentAt: '2026-05-04T16:00:00Z', customer: { name: 'David Kim', email: 'david.k@example.com' } },
    { id: 6, type: 'whatsapp', category: 'reminder', status: 'sent', sentAt: '2026-05-04T11:00:00Z', customer: { name: 'Lisa Thompson', phone: '+15553456789' } },
    { id: 7, type: 'sms', category: 'reminder', status: 'sent', sentAt: '2026-05-04T10:00:00Z', customer: { name: 'Lisa Thompson', phone: '+15553456789' } },
    { id: 8, type: 'email', category: 'reminder', status: 'sent', sentAt: '2026-05-03T09:15:00Z', customer: { name: 'James Wilson', email: 'james.w@example.com' } },
  ],
  totalActivity: 8,
  plan: 'starter',
  channelAccess: { email: true, sms: true, whatsapp: true },
  whatsappConnected: true,
  usage: {
    plan: 'starter',
    periodStart: '2026-04-15T00:00:00Z',
    email: { used: 24, limit: 500, remaining: 476, percentUsed: 5 },
    sms: { used: 9, limit: 1500, remaining: 1491, percentUsed: 1 },
    whatsapp: { used: 6, limit: Infinity, remaining: Infinity, percentUsed: 0 },
    customers: { used: 8, limit: 500, remaining: 492, percentUsed: 2 },
  },
};

export const DEMO_AUTOMATION_CONFIG = {
  reviewDelayDays: 0,
  reviewFreqDays: 0,
  maxReviews: 1,
  reminderDelayDays: 15,
  reminderFreqDays: 15,
  maxReminders: 3,
  reviewSendHour: 10,
  reviewPreferWeekends: false,
  reminderSendHour: 10,
  reminderPreferWeekends: true,
  autoRefreshTemplates: true,
  lastTemplateRefreshAt: null,
};

export const DEMO_CUSTOM_TEMPLATES = [
  {
    id: 101,
    category: 'marketing',
    channel: 'email',
    subject: "🎂 Happy Birthday, {{customer_name}}! A gift from us",
    body: "Hi {{customer_name}},\n\nWishing you a wonderful birthday! To celebrate, we're offering you an exclusive 20% off on your next visit — our little gift to you.\n\nTreat yourself, you deserve it. Book anytime this month and your discount will be applied automatically.\n\n{{booking_link}}\n\nWith love,\nGlow Beauty Salon",
    createdAt: '2026-04-10T09:00:00Z',
  },
  {
    id: 102,
    category: 'marketing',
    channel: 'sms',
    subject: null,
    body: "Hi {{customer_name}}! Flash sale this weekend only — 15% off all services. Book your spot before it's gone! {{booking_link}}",
    createdAt: '2026-04-15T11:00:00Z',
  },
  {
    id: 103,
    category: 'marketing',
    channel: 'email',
    subject: "Introducing our new Keratin Treatment ✨",
    body: "Hi {{customer_name}},\n\nWe're thrilled to announce our brand-new Keratin Smoothing Treatment — perfect for frizz-free, silky hair all season long.\n\nAs one of our valued customers, we'd love for you to be among the first to try it.\n\n{{booking_link}}\n\nSpots are limited — book yours today!",
    createdAt: '2026-04-20T14:00:00Z',
  },
  {
    id: 104,
    category: 'marketing',
    channel: 'whatsapp',
    subject: null,
    body: "Hi {{customer_name}}! 🌟 As a loyal customer, you've unlocked a special reward. Show this message at your next visit for a complimentary hair mask. Book now: {{booking_link}}",
    createdAt: '2026-04-25T10:00:00Z',
  },
];

export const DEMO_TICKETS = [
  {
    id: 51,
    subject: 'WhatsApp messages not sending',
    status: 'open',
    createdAt: '2026-05-02T10:15:00Z',
    updatedAt: '2026-05-02T10:15:00Z',
    messages: [
      {
        id: 1,
        senderType: 'user',
        message: "Hi, I've connected WhatsApp but messages are not being delivered to customers. The status shows 'sent' but customers say they haven't received anything. Can you help?",
        createdAt: '2026-05-02T10:15:00Z',
      },
    ],
  },
  {
    id: 47,
    subject: 'How to import customers from a spreadsheet?',
    status: 'resolved',
    createdAt: '2026-04-28T14:30:00Z',
    updatedAt: '2026-04-29T09:00:00Z',
    messages: [
      {
        id: 2,
        senderType: 'user',
        message: "I have about 200 customers in an Excel file. Is there a way to import them in bulk instead of adding one by one?",
        createdAt: '2026-04-28T14:30:00Z',
      },
      {
        id: 3,
        senderType: 'admin',
        message: "Hi! Yes, absolutely. Head to the Customers page and click the \"Import CSV\" button in the top-right. Export your Excel file as a .csv and make sure you have columns for Name, Email, and Phone. The importer will match them automatically.\n\nLet us know if you run into any trouble!",
        createdAt: '2026-04-28T16:00:00Z',
      },
      {
        id: 4,
        senderType: 'user',
        message: "That worked perfectly! All 200 customers imported successfully. Thank you!",
        createdAt: '2026-04-29T09:00:00Z',
      },
    ],
  },
  {
    id: 39,
    subject: 'Can I customise the sender name on emails?',
    status: 'resolved',
    createdAt: '2026-04-18T11:00:00Z',
    updatedAt: '2026-04-19T10:30:00Z',
    messages: [
      {
        id: 5,
        senderType: 'user',
        message: "Emails are going out with the sender name 'NextVisitor'. Can I change it to show our salon name instead?",
        createdAt: '2026-04-18T11:00:00Z',
      },
      {
        id: 6,
        senderType: 'admin',
        message: "Great question! The sender display name is automatically set to your business name. Go to Settings → Business Profile and make sure your business name is saved correctly. Once updated, all future emails will use that name as the sender.\n\nLet us know if you need any further help!",
        createdAt: '2026-04-18T13:45:00Z',
      },
      {
        id: 7,
        senderType: 'user',
        message: "Perfect, updated it and it's now showing 'Glow Beauty Salon'. Thanks!",
        createdAt: '2026-04-19T10:30:00Z',
      },
    ],
  },
];

export const DEMO_TEMPLATES = [
  {
    id: 1, category: 'review_request', channel: 'email',
    subject: 'We loved having you, {{customer_name}}!',
    body: "Hi {{customer_name}},\n\nIt was such a pleasure having you at Glow Beauty Salon! We put a lot of care into everything we do, and it truly means the world that you trust us.\n\nIf you have a spare moment, a quick review would mean so much to us — it helps others find us and keeps us motivated.\n\n{{review_link}}\n\nThank you from the bottom of our hearts!",
  },
  {
    id: 7, category: 'review_request', channel: 'email',
    subject: 'How was your experience, {{customer_name}}?',
    body: "Hi {{customer_name}},\n\nWe hope you're feeling amazing after your visit! Our team works hard to make every appointment special, and your opinion means everything to us.\n\nIf you enjoyed your time with us, we'd be so grateful if you could share a few words:\n\n{{review_link}}\n\nYour feedback helps us grow and serve you better every time.\n\nWith gratitude,\nGlow Beauty Salon",
  },
  {
    id: 2, category: 'reminder', channel: 'email',
    subject: "We'd love to see you again, {{customer_name}}!",
    body: "Hi {{customer_name}},\n\nIt's been a while since your last visit, and we've been thinking about you!\n\nWhenever you're ready, we'd love to take care of you again. Your favourite styles, your favourite chair — everything is here waiting.\n\n{{booking_link}}\n\nSee you soon!",
  },
  {
    id: 8, category: 'reminder', channel: 'email',
    subject: "Your hair is calling, {{customer_name}} 💇",
    body: "Hi {{customer_name}},\n\nJust a gentle reminder that it might be time to freshen up your look! We'd love to welcome you back and make sure you're feeling your absolute best.\n\nBook at a time that suits you — we're flexible and always happy to see you.\n\n{{booking_link}}\n\nCan't wait to see you again!\n\nWarm regards,\nGlow Beauty Salon",
  },
  {
    id: 3, category: 'review_request', channel: 'sms',
    subject: null,
    body: "Hi {{customer_name}}! Thank you for visiting Glow Beauty Salon 💛 We'd love it if you could leave us a quick review — it means the world to us: {{review_link}}",
  },
  {
    id: 4, category: 'reminder', channel: 'sms',
    subject: null,
    body: "Hi {{customer_name}}! It's been a while 😊 We'd love to see you again at Glow Beauty Salon. Ready to book? {{booking_link}}",
  },
  {
    id: 5, category: 'review_request', channel: 'whatsapp',
    subject: null,
    body: "Hi {{customer_name}}! We loved having you at Glow Beauty Salon 💛 We'd really appreciate a quick review — it helps us so much: {{review_link}}",
  },
  {
    id: 6, category: 'reminder', channel: 'whatsapp',
    subject: null,
    body: "Hi {{customer_name}}! We've been thinking about you 😊 It's been a while since your last visit — we'd love to take care of you again! {{booking_link}}",
  },
];

export const DEMO_SENT_MESSAGES = {
  total: 6,
  items: [
    { id: 1, type: 'email', category: 'review_request', status: 'sent', sentAt: '2026-05-05T14:30:00Z', deliveryStatus: 'clicked', customer: { name: 'Sarah Johnson', email: 'sarah.j@example.com' } },
    { id: 3, type: 'sms', category: 'reminder', status: 'sent', sentAt: '2026-05-05T12:00:00Z', deliveryStatus: 'delivered', customer: { name: 'Emily Rodriguez', phone: '+15554567890' } },
    { id: 4, type: 'email', category: 'reminder', status: 'sent', sentAt: '2026-05-05T12:00:00Z', deliveryStatus: 'delivered', customer: { name: 'Emily Rodriguez', email: 'emily.r@example.com' } },
    { id: 5, type: 'email', category: 'review_request', status: 'sent', sentAt: '2026-05-04T16:00:00Z', deliveryStatus: 'delivered', customer: { name: 'David Kim', email: 'david.k@example.com' } },
    { id: 7, type: 'sms', category: 'reminder', status: 'sent', sentAt: '2026-05-04T10:00:00Z', deliveryStatus: 'delivered', customer: { name: 'Lisa Thompson', phone: '+15553456789' } },
    { id: 8, type: 'email', category: 'reminder', status: 'sent', sentAt: '2026-05-03T09:15:00Z', deliveryStatus: 'bounced', customer: { name: 'James Wilson', email: 'james.w@example.com' } }
  ]
};

export const DEMO_LINK_CLICKS = {
  total: 14,
  items: [
    { id: 1, channel: 'email', customerName: 'Sarah Johnson', customerEmail: 'sarah.j@example.com', clickedAt: '2026-05-05T15:30:00Z' },
    { id: 2, channel: 'sms', customerName: 'Emily Rodriguez', customerPhone: '+15554567890', clickedAt: '2026-05-05T12:45:00Z' },
    { id: 3, channel: 'email', customerName: 'David Kim', customerEmail: 'david.k@example.com', clickedAt: '2026-05-04T17:20:00Z' },
    { id: 4, channel: 'sms', customerName: 'Lisa Thompson', customerPhone: '+15553456789', clickedAt: '2026-05-04T11:15:00Z' },
    { id: 5, channel: 'email', customerName: 'Emily Rodriguez', customerEmail: 'emily.r@example.com', clickedAt: '2026-05-05T13:00:00Z' }
  ]
};

export const DEMO_QUEUED_MESSAGES = {
  total: 12,
  items: [
    { id: 101, type: 'email', category: 'reminder', scheduledAt: '2026-09-08T10:00:00Z', customer: { name: 'Sarah Johnson', email: 'sarah.j@example.com' } },
    { id: 102, type: 'sms', category: 'review_request', scheduledAt: '2026-09-08T14:30:00Z', customer: { name: 'Michael Chen', phone: '+15559876543' } },
    { id: 103, type: 'email', category: 'reminder', scheduledAt: '2026-09-09T09:15:00Z', customer: { name: 'Emily Rodriguez', email: 'emily.r@example.com' } },
    { id: 104, type: 'sms', category: 'reminder', scheduledAt: '2026-09-09T11:00:00Z', customer: { name: 'David Kim', phone: '+15554561234' } },
    { id: 105, type: 'email', category: 'review_request', scheduledAt: '2026-09-10T10:30:00Z', customer: { name: 'Lisa Thompson', email: 'lisa.t@example.com' } },
    { id: 106, type: 'email', category: 'reminder', scheduledAt: '2026-09-10T15:00:00Z', customer: { name: 'James Wilson', email: 'james.w@example.com' } }
  ]
};
